import Button from "components/UI/Button";
import wellsFargoLogo from "images/logos/wells-fargo-logo.png";
import enterpriseLogo from "images/logos/enterprise-logo.png";

export const WelcomeMessage = ({ setStep }: { setStep: () => void }) => {
  return (
    <>
      <div className="">
        <h2 className="mt-0 text-primaryColor-normal border-l-4 border-green-500 px-6 py-2">
          Welcome to the Faith-Based Development Guide
        </h2>
      </div>
      <div className=" px-6 flex justify-center items-center gap-5">
        <img src={enterpriseLogo} alt="Enterprise Logo" />
        <img
          src={wellsFargoLogo}
          alt="Wells Fargo Logo"
          className="object-sale-down w-16"
        />
      </div>
      <section className="mt-10 px-6 space-y-4">
        <p>
          Thank you for your interest in the Faith-Based Development guide, an
          affordable housing and community development resource platform for
          houses of worship, created by Enterprise Community Partners
          (Enterprise) with support from Wells Fargo.
        </p>
        <p>
          Enterprise is a national nonprofit that exists to make a good home
          possible for the millions of families without one. We support
          community development organizations on the ground, aggregate and
          invest capital for impact, advance housing policy at every level of
          government, and build and manage communities ourselves.
        </p>
        <p>
          Our 
          <a
            href="https://www.enterprisecommunity.org/impact-areas/preservation-and-production/faith-based-development"
            target="_blank"
            rel="noreferrer"
            className="underline text-blue-500 cursor-pointer"
          >
            Faith-Based Development Initiative
          </a>
           (FBDI) formally began in the Mid-Atlantic in 2006, where our
          partnerships with houses of worship have led to the creation and
          preservation of more than 1,500 affordable homes with thousands more
          in the pipeline. We're taking the success of the program – bringing
          together the public, private and philanthropic sectors to help houses
          of worship develop their underutilized land – and we’re expanding it
          across the country.
        </p>
        <p>
          The Faith-Based Development guide draws upon our success in the field
          to provide support to houses of worship interested in taking the next
          step in the development process – from those just starting their
          journey to those already well underway in their work.
        </p>
        <p>
          To start, please complete the intake questionnaire which will ask for
          detailed information about your house of worship and development
          plans. Once completed, it will be reviewed by our FBDI team, and if
          approved, you will receive an invitation to create credentials that
          will allow access to a variety of resources. You will also receive a
          customized lesson plan based on the information you provide so please
          provide as many details as possible. The information you provide is
          confidential and will not be shared.
        </p>
        <p className="my-5 italic">
          By using this tool, you agree that this tool in no way should be
          construed as rendering any legal, accounting or any other project
          specific advice. You also agree that this tool is provided on an
          "as-is" and "as available" basis. We, our employees, officers,
          trustees, and agents and third party content providers assume no
          responsibility for, and expressly disclaim any liability resulting
          from, the use of any material contained in this tool.
        </p>
        <div className="flex justify-end pt-4">
          <Button
            label="Get Started"
            btnStyle="btn-primary"
            btnType="button"
            onClick={setStep}
          />
        </div>
      </section>
    </>
  );
};
